
export default {

  tip: {
    timeSort: 'Sort by Update Time',
    rewardSort: 'Sort by Rewards'
  },
  label: {
    location: 'Location',
    jobType: 'Job Type',
    salary: 'Salary',
    workTime: 'Work Time',
    roleType: 'Role Type'
  },
  location: {
    city: 'City',
    region: 'District',
    area: 'CBD',
    currentCity: 'Location',
    yourLocation: 'Current Location',
    noLocation: 'Oops, we cannot get your current location. Please select.',
    hotCities: 'Hot Cities',
    allCities: 'All Cities',
    allRegions: 'All Regions',
    allAreas: 'All Areas'
  },
  jobType: {
    industry: 'Job Industry',
    type: 'Job Category',
    allIndustries: 'All Industries',
    allTypes: 'All Types'
  },
  roleType: {
    fullTime: 'Full Time',
    partTime: 'Part Time',
    intern: 'Intern'
  },
  btn: {
    confirm: 'OK'
  }
}
